export * from './module';

export * from './search-bar';
export * from './search-sources';
export * from './shared';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/search/index.ts